var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container",style:({
    background: _vm.background,
    color: _vm.color,
    width: _vm.width,
    height: _vm.height,
  }),on:{"click":_vm.cardClick}},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.value))]),_c('span',[_c('span',[_vm._v(_vm._s(_vm.name))])])]),_c('svg-icon',{staticClass:"icon",attrs:{"icon-class":_vm.icon}}),(_vm.showShadow)?_c('div',{staticClass:"card-shadow"},[_c('div',[_c('span',[_vm._v("点击查看")]),_c('svg-icon',{staticClass:"arrow-icon",attrs:{"icon-class":"arrow-right"}})],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }